/**
 * selectionAtoms - Atom for the current object/edge selection in the graph explorer.
 *
 * Used by the home page for the details panel and by history/undo to snapshot
 * and restore selection state.
 */

import { atom, type PrimitiveAtom } from 'jotai';

import type { ObjectSelection } from '../panels/ObjectMetadataPanel';

/** Current selection (node, edge, or none) for the graph explorer. */
export const ObjectSelectionAtom: PrimitiveAtom<ObjectSelection> & {
	init: ObjectSelection;
} = atom<ObjectSelection>({ kind: 'none' });
